module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// /var/www/html/ic-automation/wp-content/themes/digitalcover/node_modules/core-js/internals/path.js
// module id = 40
// module chunks = 0